// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'app/common/lib/i18n';
import type { PinFeedFilterOptionsType } from 'app/packages/pinterest-flow-types/user';
import { compose } from 'redux';
import { updatePinFeedFilterOption } from 'app/common/redux/actions/views';
import { Box, Label, SelectList } from 'gestalt';

type State = {|
  selectedFilterOption?: PinFeedFilterOptionsType,
|};

type Option = {
  label: string,
  value: string,
};

type HOCProps = {|
  dispatch: Function,
|};

type OwnProps = {|
  pinFeedFilter?: PinFeedFilterOptionsType,
|};

type Props = {|
  ...OwnProps,
  ...HOCProps,
|};

class PinFeedFilterSelectlist extends Component<Props, State> {
  state = {
    selectedFilterOption: undefined,
  };

  anchor: ?HTMLElement;

  handleClickFilterPin = ({ value }: { value: string }) => {
    const selectedFilterOption: PinFeedFilterOptionsType = (value: any);

    const { dispatch } = this.props;
    this.setState({ selectedFilterOption });

    dispatch(updatePinFeedFilterOption(selectedFilterOption));
  };

  render() {
    const { pinFeedFilter } = this.props;
    const options: Array<Option> = [
      {
        label: i18n._('All', 'All pins feed filter option'),
        value: 'ALL',
      },
      {
        label: i18n._('Video', 'Video pins feed filter option'),
        value: 'VIDEO',
      },
      {
        label: i18n._('Story', 'Story pins feed filter option'),
        value: 'STORY',
      },
      {
        label: i18n._('Tries', 'Tries feed filter option'),
        value: 'TRIES',
      },
    ];

    return (
      <Box display="flex" alignItems="center">
        <Box display="visuallyHidden">
          <Label htmlFor="pinFormat">
            {i18n._(
              'Pin format',
              'text label for select list that lets users select a pin format to display',
            )}
          </Label>
        </Box>
        <div
          ref={(el) => {
            this.anchor = el;
          }}
        >
          <Box flex="shrink">
            <SelectList
              id="boardSort"
              onChange={this.handleClickFilterPin}
              options={options}
              value={this.state.selectedFilterOption || pinFeedFilter}
            />
          </Box>
        </div>
      </Box>
    );
  }
}

export default compose(connect<Props, OwnProps, _, _, _, _>())(PinFeedFilterSelectlist);
